import { animate } from 'motion';

export const open = (element, duration = 1, easing = [0.19, 1, 0.22, 1]) =>
  animate(
    element,
    {
      maxHeight: `${element.scrollHeight}px`,
      opacity: 1
    },
    {
      duration,
      easing
    }
  );

export const close = (element, duration = 1, easing = [0.19, 1, 0.22, 1]) =>
  animate(
    element,
    {
      maxHeight: 0,
      opacity: 0
    },
    {
      duration,
      easing
    }
  );

export const hideOpacity = (
  element,
  duration = 1,
  delay = 0,
  easing = [0.19, 1, 0.22, 1]
) =>
  animate(
    element,
    {
      opacity: 0
    },
    {
      duration,
      delay,
      easing
    }
  );

export const showOpacity = (
  element,
  duration = 1,
  delay = 0,
  easing = [0.19, 1, 0.22, 1]
) =>
  animate(
    element,
    {
      opacity: 1
    },
    {
      duration,
      delay,
      easing
    }
  );

export const show = (
  element,
  duration = 1,
  delay = 0,
  easing = [0.19, 1, 0.22, 1]
) =>
  animate(
    element,
    {
      maxBlockSize: 'unset'
    },
    {
      duration,
      delay,
      easing
    }
  );

export const hide = (
  element,
  maxBlockSize = 0,
  duration = 1,
  delay = 0,
  easing = [0.19, 1, 0.22, 1]
) =>
  animate(
    element,
    {
      maxBlockSize
    },
    {
      duration,
      delay,
      easing
    }
  );

export const showFromBottom = (
  element,
  delay = 0.2,
  duration = 0.2,
  easing = [0.11, 0, 0.5, 0]
) =>
  animate(
    element,
    {
      opacity: 1,
      translateY: 0
    },
    {
      delay,
      duration,
      easing
    }
  );

export const hideFromTop = (
  element,
  delay = 0.2,
  duration = 0.2,
  easing = [0.11, 0, 0.5, 0]
) =>
  animate(
    element,
    {
      opacity: 0,
      translateY: 30
    },
    {
      delay,
      duration,
      easing
    }
  );

export const hideToRight = (
  element,
  delay = 0.2,
  duration = 0.2,
  easing = [0.11, 0, 0.5, 0]
) =>
  animate(
    element,
    {
      opacity: 0,
      translateX: 90
    },
    {
      delay,
      duration,
      easing
    }
  );

export const hideToLeft = (
  element,
  delay = 0.2,
  duration = 0.2,
  easing = [0.11, 0, 0.5, 0]
) =>
  animate(
    element,
    {
      opacity: 0,
      translateX: -90
    },
    {
      delay,
      duration,
      easing
    }
  );
